import { formatMoney } from '@shopify/theme-currency';

const quickOrderListForm = () => {
  // Get each table
  const quickOrderListEls = document.querySelectorAll('[data-quick-order-list]');
  if (!quickOrderListEls) return;
  const totalQtyEl = document.querySelector('[data-quick-order-list-total-qty]');
  const totalPriceEl = document.querySelector('[data-quick-order-list-total-price]');
  const quickOrderListBtn = document.querySelector('[data-quick-order-atc]');
  const quickOrderListAtcPayload = [];

  // Get each variant
  const variantRows = document.querySelectorAll('[data-quick-order-list-variant-id]');
  if (!variantRows) return;
  // Get the elements
  const qtyAdjuster = document.querySelectorAll('.btn-quantity-selector');

  // Loop the adjusters
  qtyAdjuster.forEach(adjuster => {
    // Listen on click
    adjuster.addEventListener('click', () => {
      // Set some defaults
      let totalQty = 0,
        totalPrice = 0;

      // For each variant row
      variantRows.forEach(row => {
        // Get the qty el
        const variantQty = parseInt(row.querySelector('[data-product-form-quantity-input]').value);
        // Get the price
        const variantPrice = parseInt(
          row.querySelector('[data-quick-order-list-variant-price]').dataset.quickOrderListVariantPrice
        );

        // Work out the total of each row
        const variantTotal = variantQty * variantPrice;

        // Appenend it to the total qty and price
        totalQty = totalQty + variantQty;
        totalPrice = totalPrice + variantTotal;

        // Set the elements content
        totalQtyEl.innerHTML = totalQty;
        totalPriceEl.innerHTML = formatMoney(totalPrice, window.theme.moneyFormat);
      });
    });
  });

  quickOrderListBtn.addEventListener('click', () => {
    // Get each variant
    const variantRows = document.querySelectorAll('[data-quick-order-list-variant-id]');
    if (!variantRows) return;
    // For each variant row
    variantRows.forEach(row => {
      // Get the id
      const variantId = row.dataset.quickOrderListVariantId;
      // Get the qty el
      const variantQty = parseInt(row.querySelector('[data-product-form-quantity-input]').value);
      if (!variantQty || !variantId) return;
      // This logic is taken from addToCart.ts
      quickOrderListAtcPayload.push({
        id: variantId,
        quantity: variantQty
      });
    });

    if (quickOrderListAtcPayload.length > 0) {
      window['blubolt'].cart.addToCart(quickOrderListAtcPayload, true, () => {
        setTimeout(() => {
          console.info('added');
        }, 3000);
      });
    }
  });
};

export default quickOrderListForm;